function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3201 44.2567C35.2362 44.2567 44.8961 34.6062 44.8961 22.7018C44.8961 10.7973 35.2362 1.14679 23.3201 1.14679C11.4039 1.14679 1.74402 10.7973 1.74402 22.7018C1.74402 34.6062 11.4039 44.2567 23.3201 44.2567Z",
  stroke: "#707070",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3201 10.8093V16.7555",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5236 14.1793L27.3149 18.3839",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2241 22.5323H29.2721",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4357 30.9818L27.299 26.7065",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3201 34.5942V28.648",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7821 30.9818L18.9188 26.7065",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4161 22.5323H17.3681",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8058 14.1646L19.1588 18.2198",
  stroke: "#707070",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgStandby = function SvgStandby(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStandby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Standby.281ff547.svg";
export { ForwardRef as ReactComponent };